import { notifySuccess, notifyError } from "@js/components/notify";

document.addEventListener("DOMContentLoaded", () => {
  // Reset Modal
  window.resetAffiliateModal = () => {
    const form = document.getElementById("affiliateForm");
    if (form) {
      form.reset();
      document.getElementById("affiliateId").value = "";
    }

    loadMitarbeiter();
    loadKontakte();
  };

  const loadMitarbeiter = () => {
    const select = document.getElementById("copyFromSelect");
    if (!select) return;

    fetch("/affiliate/api/source/mitarbeiter")
      .then((res) => res.json())
      .then((data) => {
        const optgroup = document.getElementById("mitarbeiter-optgroup");
        if (optgroup) {
          optgroup.innerHTML = "";
          data.forEach((m) => {
            const option = document.createElement("option");
            option.value = "m_" + m.id;
            option.textContent = `${m.vorname} ${m.nachname}`;
            option.dataset.vorname = m.vorname;
            option.dataset.nachname = m.nachname;
            option.dataset.email = m.email;
            option.dataset.telefon = m.telefon;
            optgroup.appendChild(option);
          });
        }
      });
  };

  const loadKontakte = () => {
    const select = document.getElementById("copyFromSelect");
    if (!select) return;

    fetch("/affiliate/api/source/kontakte")
      .then((res) => res.json())
      .then((data) => {
        const optgroup = document.getElementById("kontakte-optgroup");
        if (optgroup) {
          optgroup.innerHTML = "";
          data.forEach((m) => {
            const option = document.createElement("option");
            option.value = "k_" + m.id;
            option.textContent = `${m.vorname} ${m.nachname}`;
            option.dataset.vorname = m.vorname;
            option.dataset.nachname = m.nachname;
            option.dataset.email = m.email;
            option.dataset.telefon = m.telefon;
            optgroup.appendChild(option);
          });
        }
      });
  };

  const copyFromSelect = document.getElementById("copyFromSelect");
  if (copyFromSelect) {
    copyFromSelect.addEventListener("change", (e) => {
      const selected = e.target.options[e.target.selectedIndex];
      if (selected.value) {
        document.getElementById("affiliateVorname").value = selected.dataset.vorname || "";
        document.getElementById("affiliateNachname").value = selected.dataset.nachname || "";
        document.getElementById("affiliateEmail").value = selected.dataset.email || "";
        document.getElementById("affiliateTelefon").value = selected.dataset.telefon || "";
      }
    });
  }

  // Link Generator
  window.generateCampaignLink = () => {
    const campaignSelect = document.getElementById("campaignSelect");
    const redirectUrl = document.getElementById("affiliateRedirectUrl");

    if (campaignSelect && campaignSelect.value) {
      let path = campaignSelect.value;
      try {
        const urlObj = new URL(path);
        path = urlObj.pathname + urlObj.search;
      } catch (e) {
        // Not a full URL, ignore
      }
      if (!path.startsWith("/")) {
        path = "/" + path;
      }
      redirectUrl.value = window.location.origin + path;
    } else {
      if (typeof cs !== "undefined" && cs.Swal) {
        cs.Swal.fire({ icon: "warning", title: "Achtung", text: "Bitte eine Kampagne auswählen." });
      } else {
        notifyError("Bitte eine Kampagne auswählen.");
      }
    }
  };

  window.generateWhatsAppLink = () => {
    const number = document.getElementById("waZielnummer").value.replace(/[^0-9]/g, "");
    const text = encodeURIComponent(document.getElementById("waText").value);
    const redirectUrl = document.getElementById("affiliateRedirectUrl");

    if (number) {
      let url = `https://wa.me/${number}`;
      if (text) {
        url += `?text=${text}`;
      }
      redirectUrl.value = url;
    } else {
      notifyError("Bitte eine Zielnummer eingeben");
    }
  };
});
